/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


const sizeOptions = {
  SMALL: '10px',
  MEDIUM: '12px',
  LARGE: '14px'
}


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - COLORS: STYLES --------------- ++++++++++ */
export default theme => ({
  emojireaction: {
    background: ({ themeColors }) => themeColors ? themeColors.backgroundSecondary : '#e7eaf7',
    borderRadius: pxToEm(20),
    padding: '4px 6px',
    gap: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& span': {
      color: ({ themeColors }) => themeColors ? themeColors['neutrals.bodyText'] : '#000000',
      fontWeight: 600,
      fontSize: ({ size }) => sizeOptions[size || 'STANDARD']
    },
    '& img': {
      filter: ({ type, darkMode }) => type === 'MONOCHROME' && darkMode ? 
        'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(2%) hue-rotate(115deg) brightness(103%) contrast(101%)' 
        : 'initial'
    }
  }
});
